/**
 * Utilitário de rascunhos persistentes para editores de comentário.
 * Armazena HTML no localStorage por escopo (novo, edição, resposta).
 */

const PREFIX = 'seasymon:draft:comment';

export const newKey    = (cardId)    => `${PREFIX}:new:${cardId}`;
export const editKey   = (commentId) => `${PREFIX}:edit:${commentId}`;
export const replyKey  = (commentId) => `${PREFIX}:reply:${commentId}`;

/**
 * HTML vazio segundo o TipTap: string vazia, <p></p>, só espaços/brs.
 */
export function isEmptyHtml(html) {
  if (!html) return true;
  const stripped = html.replace(/<[^>]+>/g, '').trim();
  // ainda tem conteúdo visual (texto, imagens inline)
  if (stripped) return false;
  // sem texto mas pode ter imagem inline
  if (html.includes('<img')) return false;
  return true;
}

export function loadDraft(key) {
  try {
    return localStorage.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function saveDraft(key, html) {
  try {
    if (isEmptyHtml(html)) {
      clearDraft(key);
    } else {
      localStorage.setItem(key, html);
    }
  } catch {
    // modo privado ou storage cheio — ignora silenciosamente
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignora
  }
}

// Debounce simples para não gravar a cada tecla
const timers = {};
export function saveDraftDebounced(key, html, delay = 400) {
  clearTimeout(timers[key]);
  timers[key] = setTimeout(() => saveDraft(key, html), delay);
}
